import type { LongRunningExportType } from '../actions/export';

export const LongRunningTaskStatus = {
	RUNNING: 'running',
	COMPLETED: 'completed',
	COMPLETED_WARNINGS: 'completed-warnings',
	COMPLETED_ERRORS: 'completed-errors',
	FAILED: 'failed',
} as const;

export type LongRunningTaskStatus = (typeof LongRunningTaskStatus)[keyof typeof LongRunningTaskStatus];

export const LongRunningTaskType = {
	EXPORT: 'export',
} as const;

export type LongRunningTaskType = (typeof LongRunningTaskType)[keyof typeof LongRunningTaskType];

/** File info for a completed export task (no notifications — those live at the response/document level) */
export interface ExportTaskResult {
	exportId: string;
	fileName: string;
	url: string;
}

export interface ExportTaskPayload {
	/** The type of long-running export */
	exportType: LongRunningExportType;
	/** Flat array of collection revision strings */
	revisions: string[];
	/** Client's timezone (e.g. 'Pacific/Auckland') for filename dates and content formatting */
	timezone: string;
	/** Whether to exclude photos from the export */
	noPhotos?: boolean;
}
